import { Label as LabelPrimitive } from 'radix-ui';
import { forwardRef, type ComponentPropsWithoutRef } from 'react';

import { cn } from '../cn';

export const Label = forwardRef<HTMLLabelElement, ComponentPropsWithoutRef<typeof LabelPrimitive.Root>>(function Label(
  { className, ...props },
  ref,
) {
  return <LabelPrimitive.Root ref={ref} className={cn('text-label text-ink-secondary', className)} {...props} />;
});
